/* SEP 27 2026 PERF PASS: lightweight loader. The full Opera sidebar audit (37 KB) lives in
   sq-opera-sidebar-audit-full-v1.js and is only downloaded when the page URL contains
   ?sq_opera_audit=1. Shoppers no longer download the audit on every collection page. */
(function(){
  if(new URLSearchParams(location.search).get('sq_opera_audit')!=='1')return;
  var me=document.currentScript;
  var src=me&&me.src?me.src.replace('sq-opera-sidebar-audit-v1.js','sq-opera-sidebar-audit-full-v1.js'):'';
  if(!src||src===(me&&me.src))return;
  var s=document.createElement('script');
  s.src=src;
  (document.head||document.documentElement).appendChild(s);
})();
